import { useQuery } from '@tanstack/react-query';
import type {
  PerLocationRevenueResponse, PerLocationRevenueRange,
} from '@evi/shared';
import { fetchPerLocationRevenue } from '@/lib/api';

/**
 * Per-location revenue widget data hook. Range parameter is
 * part of the queryKey so toggling 7d ↔ 30d swaps cached entries
 * rather than refetching the same range. Live: session events
 * refetch it through LiveUpdatesProvider; no poll.
 */
export function usePerLocationRevenue(range: PerLocationRevenueRange) {
  return useQuery<PerLocationRevenueResponse>({
    queryKey: ['dashboard', 'per-location-revenue', range],
    queryFn: () => fetchPerLocationRevenue(range),
    staleTime: 60_000,
  });
}
